import { INITIAL_STATE_HYDRATION_OMIT, INITIAL_STATE_POJO_KEYS } from './initialStateConstants';
import { produceImmutableReducerState } from '../offline/cache/utils/rebuildPersistedState';

const { requestStateSync } = window.desktopIntegration;

const prepareState = (state: Record<string, unknown>) => {
    const immutableState = produceImmutableReducerState(state, INITIAL_STATE_POJO_KEYS, INITIAL_STATE_HYDRATION_OMIT);

    // Start as non-guest. The renderer will validate persisted auth and fall back to guest when needed.
    const authenticatedState = immutableState.setIn(['app', 'currentUser', 'isGuest'], false);

    return authenticatedState;
};

const getElectronInitialState = () => {
    const state = requestStateSync();
    if (!state) return;

    const preparedState = prepareState(state);
    return preparedState;
};

export default getElectronInitialState;
